export const shippingCartons = [
   { name: '20GP', maxCbm: 27.5, cost: 600 },
   { name: '40GP', maxCbm: 54, cost: 700 },
   { name: '40HQ', maxCbm: 67.5, cost: 700 },
];
